<template>
  <div id="mainmenu">
    <div class="mb-4" v-show="menuCheck('jobsites')">
      <Link class="group flex items-center py-3" href="/">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Jobsites</div>
      </Link>
    </div>
    <div class="mb-4" v-show="menuCheck('daylogs')">
      <Link class="group flex items-center py-3" href="/daylogs">
        <icon name="clipboard-check" class="mr-2 w-4 h-4" style="transform:scale(1.5);" :class="isUrl('daylogs') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('daylog') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Day Logs</div>
      </Link>
    </div>
    <div class="mb-4" v-show="menuCheck('purchaseorders')">
      <Link class="group flex items-center py-3" href="/purchaseorders">
        <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('purchaseorders') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('purchaseorders') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">POs</div>
      </Link>
    </div>
    <div class="mb-4" v-show="menuCheck('orders')">
      <Link class="group flex items-center py-3" href="/orders">
        <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('orders') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('orders') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Orders</div>
      </Link>
    </div>
    <div class="mb-4" v-show="menuCheck('inventory')">
      <Link class="group flex items-center py-3" href="/inventory">
        <icon name="printer" class="mr-2 w-4 h-4" :class="isUrl('inventory') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('inventory') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Inventory</div>
      </Link>
    </div>
    <div class="mb-4" v-show="menuCheck('reports')">
      <Link class="group flex items-center py-3" href="/reports">
        <icon name="printer" class="mr-2 w-4 h-4" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Reports</div>
      </Link>
    </div>
    <div class="mb-4" v-show="menuCheck('users')">
      <Link class="group flex items-center py-3" href="/users">
        <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Users</div>
      </Link>
    </div>
    <div class="mb-4" v-show="menuCheck('vendors')">
      <Link class="group flex items-center py-3" href="/vendors">
        <icon name="vendors" class="mr-2 w-4 h-4" :class="isUrl('vendors') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('vendors') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Vendors</div>
      </Link>
    </div>
  </div>
</template>
<style>
  #mainmenu {
    background:#FFFFFF;
    color:#13B7E0 !important;
  }
  #mainmenu .fill-white { fill:#272628 !important; }
  #mainmenu .text-white { color:#272628 !important; }
  .fill-indigo-400 { fill:#13B7E0 !important; }
  #mainmenu .text-indigo-300 {
    color:#13B7E0 !important;
  }
  .mobilemenu { 
    background:#FFF;
  }
  .mobilemenu .mb-4 {
    margin:20px 25px;
  }
</style>
<script>
import { Link, useRemember } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  setup(props) {
  },
  components: {
    Icon,
    Link,
  },
  props: {
    auth: Object,
    role: String,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
    menuCheck(mstr) {
      if (this.role == 'ADMIN') {
        return true;
      }
      else if (this.role == 'VENDOR') { // VIEW ONLY, 
        if (mstr == 'jobsites') {}
        if (mstr == 'daylogs') { return true;  }
        if (mstr == 'purchaseorders') { return true; }
        if (mstr == 'orders') { return true; } //CAN EDIT ???
        if (mstr == 'inventory') { return false; }
        if (mstr == 'reports') { }
        if (mstr == 'users') { }
        if (mstr == 'vendors') { }
      }
      else if (this.role == 'SUPER') { // SEE ALL, UPLOAD DAILY, UPLOAD ORDERS
        if (mstr == 'jobsites') { }
        if (mstr == 'daylogs') { return true; } // EDIT HERE ONLY
        if (mstr == 'purchaseorders') { return true; }
        if (mstr == 'orders') { return true; } // ONLY SEE, CANT UNFINALIZE
        if (mstr == 'inventory') { return true; }
        if (mstr == 'reports') { return true; }
        if (mstr == 'users') { }
        if (mstr == 'vendors') { }
      }
      else if (this.role == 'USER') { // SEE ALL ONLY
        if (mstr == 'jobsites') { }
        if (mstr == 'daylogs') { return true; }
        if (mstr == 'purchaseorders') { return true; }
        if (mstr == 'orders') { return true; }
        if (mstr == 'inventory') { return true; }
        if (mstr == 'reports') { return true; }
        if (mstr == 'users') { }
        if (mstr == 'vendors') { }
      }
      else if (this.role == 'CLIENT') {
        if (mstr == 'jobsites') { }
        if (mstr == 'daylogs') { return true; }
        if (mstr == 'purchaseorders') { return true; }
        if (mstr == 'orders') { return true; }
        if (mstr == 'inventory') { return true; }
        if (mstr == 'reports') { return true; }
        if (mstr == 'users') { }
        if (mstr == 'vendors') { }
      }
      else { 
        return false;
      }
      return false;
    },
  },
}
</script>
